import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AlertTransactionsResponse } from '@/types/alertDetail';

/**
 * GET /api/v1/alerts/{id}/transactions
 *
 * Returns the source-of-truth transactions tied to an alert (the rows
 * referenced by `related_transaction_ids`). Drives the
 * TransactionMapSection (and, in PR 4, the actual MapLibre embed) plus
 * the lat/lon placeholder text in PR 2.
 */
export function useAlertTransactions(
  alertId: number | undefined,
): UseQueryResult<AlertTransactionsResponse, Error> {
  return useQuery<AlertTransactionsResponse, Error>({
    queryKey: ['alert', alertId, 'transactions'],
    enabled: alertId != null,
    queryFn: async () => {
      const resp = await api.get<AlertTransactionsResponse>(
        `/alerts/${alertId}/transactions`,
      );
      return resp.data;
    },
  });
}
